module.exports = __webpack_public_path__ + "img/edit.a032355e.svg";